import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isEquipmentLoading: false,
    isTransferTypeLoading: false,
    isReportNameLoading: false,
    isEquipmentMaterialLoading: false,
    isEquipmentCategorieLoading: false,
    isEquipmentMaterialGroupLoading: false,
    isEquipmentStatuseLoading: false,
    error: null,
    equipments: null,
    transfer_types: null,
    equipment_materials: null,
    equipment_categories: null,
    equipment_material_groups: null,
    rev_codes: null,
    isRevCodeLoading: false,
    equipment_statuses: null,
    isMaterialLoading: false,
    materialCode: null
};

const slice = createSlice({
    name: 'equipment',
    initialState,
    reducers: {
        // START LOADING
        startEquipmentLoading(state) {
            state.isEquipmentLoading = true;
        },
        startMaterialCodeLoading(state) {
            state.isMaterialLoading = true;
        },
        startTransferTypeLoading(state) {
            state.isTransferTypeLoading = true;
        },
        startReportNameLoading(state) {
            state.isReportNameLoading = true;
        },
        startEquipmentMaterialLoading(state) {
            state.isEquipmentMaterialLoading = true;
        },
        startEquipmentCategorieLoading(state) {
            state.isEquipmentCategorieLoading = true;
        },
        startEquipmentMaterialGroupLoading(state) {
            state.isEquipmentMaterialGroupLoading = true;
        },
        startEquipmentStatuseLoading(state) {
            state.isEquipmentStatuseLoading = true;
        },
        startRevCodeLoading(state) {
            state.isRevCodeLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isEquipmentLoading = false;
            state.isTransferTypeLoading = false;
            state.isReportNameLoading = false;
            state.isEquipmentMaterialLoading = false;
            state.isEquipmentCategorieLoading = false;
            state.isEquipmentMaterialGroupLoading = false;
            state.isEquipmentStatuseLoading = false;
            state.isRevCodeLoading = false;
            state.error = action.payload;
        },
        // GET EQUIPMENT
        setEquipments(state, action) {
            state.isEquipmentLoading = false;
            state.equipments = action.payload;
        },
        // GET TRANSFER TYPES
        setTransferTypes(state, action) {
            state.isTransferTypeLoading = false;
            state.transfer_types = action.payload;
        },

        setReportNames(state, action) {
            state.isReportNameLoading = false;
            state.report_names = action.payload;
        },
        // GET EQUIPMENT MATERIALS
        setEquipmentMaterials(state, action) {
            state.isEquipmentMaterialLoading = false;
            state.equipment_materials = action.payload;
        },
        // GET EQUIPMENT CATEGORIES
        setEquipmentCategories(state, action) {
            state.isEquipmentCategorieLoading = false;
            state.equipment_categories = action.payload;
        },
        // GET EQUIPMENT MATERIAL GROUPS
        setEquipmentMaterialGroups(state, action) {
            state.isEquipmentMaterialGroupLoading = false;
            state.equipment_material_groups = action.payload;
        },
        // GET EQUIPMENT STATUSES
        setEquipmentStatuses(state, action) {
            state.isEquipmentStatuseLoading = false;
            state.equipment_statuses = action.payload;
        },
        setmaterialCode(state, action) {
            state.isMaterialLoading = false;
            state.materialCode = action.payload;
        },
        setRevCodes(state, action) {
            state.isRevCodeLoading = false;
            state.rev_codes = action.payload;
        }
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startEquipmentLoading,
    startTransferTypeLoading,
    startReportNameLoading,
    startEquipmentMaterialLoading,
    startEquipmentCategorieLoading,
    startEquipmentMaterialGroupLoading,
    startEquipmentStatuseLoading,
    startMaterialCodeLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getEquipments(params = {}, fetchUrl = "/dropdown/equipment/equipments") {
    return async () => {
        dispatch(slice.actions.startEquipmentLoading());
        try {
            const response = await axios.get(fetchUrl,{
                params: params,
            });
            dispatch(slice.actions.setEquipments(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getMaterialCode() {
    return async () => {
        dispatch(slice.actions.startMaterialCodeLoading());
        try {
            const response = await axios.get(`/admin/equipment/dropdown/equipment_fuel_Material_code`);
            dispatch(slice.actions.setmaterialCode(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAvaliableEquipments() {
    return async () => {
        dispatch(slice.actions.startEquipmentLoading());
        try {
            const response = await axios.get(`/admin/equipment/dropdown/available_equipments`);
            dispatch(slice.actions.setEquipments(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTransferTypes() {
    return async () => {
        dispatch(slice.actions.startTransferTypeLoading());
        try {
            const response = await axios.get(`/admin/equipment/transfer_types`);
            dispatch(slice.actions.setTransferTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getReportNames() {
    return async () => {
        dispatch(slice.actions.startReportNameLoading());
        try {
            const response = await axios.get(`/admin/report/reports`);
            dispatch(slice.actions.setReportNames(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getEquipmentMaterial() {
    return async () => {
        dispatch(slice.actions.startEquipmentMaterialLoading());
        try {
            const response = await axios.get(`/admin/equipment_materials`);
            dispatch(slice.actions.setEquipmentMaterials(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getEquipmentCategory() {
    return async () => {
        dispatch(slice.actions.startEquipmentCategorieLoading());
        try {
            const response = await axios.get(`/admin/equipment/equipment_categories`);
            dispatch(slice.actions.setEquipmentCategories(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getEquipmentMaterialGroup() {
    return async () => {
        dispatch(slice.actions.startEquipmentMaterialGroupLoading());
        try {
            const response = await axios.get(`/admin/equipment/equipment_material_groups`);
            dispatch(slice.actions.setEquipmentMaterialGroups(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getEquipmentStatus() {
    return async () => {
        dispatch(slice.actions.startEquipmentStatuseLoading());
        try {
            const response = await axios.get(`/admin/equipment/equipment_statuses`);
            dispatch(slice.actions.setEquipmentStatuses(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getRevCodes(params = {}) {
    return async () => {
        dispatch(slice.actions.startRevCodeLoading());
        try {
            const response = await axios.get(`/admin/equipment/rev_codes`, {
                params: params,
            });
            dispatch(slice.actions.setRevCodes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
